import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountingViewComponent } from './accounting-view/accounting-view.component';
import { NotificationsViewComponent } from './notifications-view/notifications-view.component';
import { OrganizationEditorViewComponent } from './organization-editor-view/organization-editor-view.component';
import { ResourceEditorComponent } from './resources/resource-editor-view/resource-editor-view.component';
import { ResourceListViewComponent } from './resources/resource-list-view/resource-list-view.component';
import { SettingsViewComponent } from './settings-view/settings-view.component';
import { DeveloperViewComponent } from './developer-view/developer-view.component';
import { PlanningViewComponent } from './planning-view/planning-view.component';
import { SubscriptionViewComponent } from './subscription-view/subscription-view.component';
import { environment } from 'src/environments/environment';
import { ProfileEditorViewComponent } from './profile-editor-view/profile-editor-view.component';

const routes: Routes = [
    {
        path: '',
        component: SettingsViewComponent,
        //canActivate: [AuthGuardService],
        children: [
            { path: '', redirectTo: 'organization', pathMatch: 'full' },
            { path: 'profile', component: ProfileEditorViewComponent },
            { path: 'organization', component: OrganizationEditorViewComponent },
            { path: 'people', component: ResourceListViewComponent },
            { path: 'people/:id', component: ResourceEditorComponent },
            { path: 'accounting', component: AccountingViewComponent },
            { path: 'customer-notifications', component: NotificationsViewComponent },
            { path: 'api-keys', component: DeveloperViewComponent },
            { path: 'planning', component: PlanningViewComponent },
            { path: 'subscription', component: SubscriptionViewComponent },
            //{ path: 'advanced', component: AdvancedViewComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {enableTracing: true})],
    exports: [RouterModule]
})
export class SettingsRoutingModule { }
